import dayjs from "dayjs";

export default (datetime) => {
  if (datetime) {
    let dateObj = dayjs(datetime, {utc: true});
    const weekday = dateObj.day();

    if (weekday == 0) {
      dateObj = dateObj.add(1, 'day');
    } else if (weekday == 6) {
      dateObj = dateObj.add(2, 'day');
    }

    if (dateObj.hour() < 8) {
      dateObj = dateObj.hour(8);
      dateObj = dateObj.minute(0);
    } else if (dateObj.hour() > 17) {
      dateObj = dateObj.hour(16);
      dateObj = dateObj.minute(59);
    }

    datetime = dateObj.format().substring(0, '0000-00-00T00:00'.length);
  }

  return datetime;
}
